















































































































































































































import { Component, Ref, Vue, Watch, Prop, PropSync } from "vue-property-decorator";
import { NotificationEventBus } from "@/EventBus";
import ImagePicker from "@/components/common/ImagePicker.vue";
import FileSelector from "@/components/common/FileSelector.vue";
import ChoiceSubmitterGroup from "@/views/ChoiceSubmitter/ChoiceSubmitterRecursiveGroup.vue";
import { getModule } from "vuex-module-decorators";

import Decisions from "@/store/modules/Decisions";
import Choices, { Choice } from "@/store/modules/Choices";
import Sticky from 'vue-sticky-directive';
import { Urls } from "@/Urls";
import Modelling from "@/store/modules/Modelling";
import { FactorResource } from '@/api/model/FactorResource';
import { FactorGroup } from '@/api/model/FactorResource';
import { VIEWPOINT_API } from "@/api/ViewpointApi";
import ExportPreview from "@/views/FileExport/ExportPreview.vue"
import ConfirmationDialog from "@/components/common/ConfirmationDialog.vue";
import _ from "lodash";
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";
import Apps from '@/store/modules/Apps';
import Users from "@/store/modules/Users";
import CreateChoiceDialog from '@/views/ChoiceCards/CreateChoiceDialog.vue';
import ChoiceSelectCommon from '@/components/common/ChoiceSelectCommon.vue'


const modellingModule = getModule(Modelling);
const decisionsModule = getModule(Decisions);
const choicesModule = getModule(Choices);
const appsModule = getModule(Apps);
const workspaceOptionsModule = getModule(WorkspaceOptions);

@Component({
    components: {
        ImagePicker,
        FileSelector,
        ChoiceSubmitterGroup,
        ExportPreview,
        ConfirmationDialog,
        CreateChoiceDialog,
        ChoiceSelectCommon
    },
    directives: {
        Sticky,
    },
       beforeRouteLeave(to, from , next) {
        if(this.unsavedChanges) {
            const answer = window.confirm('You currently have unsaved changes. Are you sure you want to leave?')
            if (answer) {
                next()
            } else {
                return;
            }
        } else{
            next()
        }
       
    }
})
export default class ChoiceSubmitter extends Vue {
    @Prop({default:false, type:Boolean})
    appEmbed!: boolean;

    @Prop({default:false, type:Boolean})
    isNewChoice!: boolean

    @Prop({ default: false, type: Boolean})
    isDialog!: false;

    @Prop({ default:false, type: Boolean })
    dialogSave!: false;

    @Prop({ default: false, type: Boolean })
    dialogClear!: false;

    @Prop({default: true, type: Boolean})
    addToList!: boolean;

    @Prop({ default: '', type: String })
    choiceId!: string;

    @Prop({ default: false, type: Boolean })
    isNewChoiceNameDialog!: false;
    

    private isEditChoiceName:boolean = false;

    @Watch('dialogClear')
    onChangeDialogClear() {
        if (this.dialogClear) {
            this.resetVars();
            this.$emit('clearcomplete');
        }
    }

    @Watch('isNewChoiceNameDialog')
    onChangeIsNewChoiceNameDialog(){
        if (this.isNewChoiceNameDialog){
            this.createChoiceDialog = true;
        }
    }



    @Watch('dialogSave')
    onChangeDialogSave() {
        if (this.dialogSave) {
            this.createChoice();
        }
    }

    get selectionMenu() {
        return appsModule.selectionMenu;
    }

    get isOwnerOrAdmin() {
        return decisionsModule.isAdminOrOwner;
    }

    get appMenuName(){
        return appsModule.activeAppMenuName;
    }

    get commentBottomHeight(){
        return workspaceOptionsModule.commentBottomHeight;
    }
    
    get commentVertical() {
        return workspaceOptionsModule.commentVertical;
    }

    get pinnedRight() {
        return workspaceOptionsModule.pinnedRight;
    }

    get cardContainerSize() {
        if (this.isDialog) {
            return `min-height:100%;max-height:100%`
        }
        let commentHeight = 0;
        if (this.commentVertical && this.pinnedRight) {
            commentHeight = this.commentBottomHeight;
        } else if (!this.pinnedRight && this.appEmbed) {
            commentHeight = 40;
        } else {
            commentHeight = 0;
        }
        if(this.appEmbed){
            return `min-height: calc(100vh - 74px - ${commentHeight}px);`;
        }else{
             return `min-height:calc(100vh - 160px - ${commentHeight}px);`;
        }
    }

     get mainContainerSize() {
        if (this.isDialog) {
            return `min-height:100%;max-height:100%`
        }
        let commentHeight = 0;
        if (this.commentVertical && this.pinnedRight) {
            commentHeight = this.commentBottomHeight;
        } else if (!this.pinnedRight && this.appEmbed) {
            commentHeight = 40;
        } else {
            commentHeight = 0;
        }
        if(this.appEmbed){
            return `min-height: calc(100vh - 38px- ${commentHeight}px); max-height: calc(100vh - 38px - ${commentHeight}px);`;
        }else{
             return `max-height : calc(100vh - 125px - ${commentHeight}px); min-height:calc(100vh - 125px - ${commentHeight}px)`;
        }
    }

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    get selectedChoice(): Choice {
        if (this.choiceId && choicesModule.choices && choicesModule.choices[this.choiceId] ){
            return choicesModule.choices[this.choiceId]
        } else {
            return choicesModule.selectedChoice
        }
    }

    get factorResources() {
        return modellingModule.publishedModelFactorResources
    }

    get edit() {
        return this.selectedChoice != null;
    }

    get choicesList() {
        return choicesModule.choicesList
    }

    get len() {
        return choicesModule.choicesList.length
    }

    get previousChoice() {
        let index = this.choicesList.indexOf(this.selectedChoice)
        if(index > 0 && this.choicesList.length > 1) {
            return this.choicesList[index-1].name;
        }

        if(index === 0 && this.choicesList.length > 1) {
            return this.choicesList[this.choicesList.length-1].name;
        }
    }

    get nextChoice() {
        let index = this.choicesList.indexOf(this.selectedChoice)
        if(index < this.choicesList.length-1 && this.choicesList.length > 1) {
           return this.choicesList[index+1].name;
        }

        if(index === this.choicesList.length-1 && this.choicesList.length > 1) {
            return this.choicesList[0].name;
        }
    }

    get singularChoiceLabel() {
        return decisionsModule.singularChoiceLabel;
    }

    get pluralChoiceLabel() {
        return decisionsModule.pluralChoiceLabel
    }

    set selectedChoice(choice: Choice) {
        if (choice){
            choicesModule.selectChoice(choice.id)
            this.menu = false;
        }
    }

    get startingFactors() {
        if(workspaceOptionsModule.trimTopGroups) {
            let topFactor = 'M'
            return this.getTopGroup('M')
        
        } else {
            return ['M']
        }
        
    }

    private getTopGroup(topId: string) {
        if(this.factorResources[topId].childrenIds.length != 1 ? true: 'groupTypeDefinition' in this.factorResources[this.factorResources[topId].childrenIds[0]] || this.factorResources[this.factorResources[topId].childrenIds[0]].type != 'FACTOR_GROUP') {
            return this.factorResources[topId].childrenIds
        }

        if(this.factorResources[topId].childrenIds.length === 1) {
            return this.getTopGroup(this.factorResources[topId].childrenIds[0])
        }
    }

    get activeChoiceLists() {
        return workspaceOptionsModule.activeChoiceLists
    }

    get ownerOfChoice() {
        if(this.selectedChoice === null) {
            return 'You'
        }
        
        let usersModule = getModule(Users);
        if(this.selectedChoice?.ownerUserId != null) {
            if(this.selectedChoice?.ownerUserId === usersModule.currentUserProfile.userId) {
                return 'You'
            }
            return `${decisionsModule.selectedDecisionUsers[this.selectedChoice?.ownerUserId].first} ${decisionsModule.selectedDecisionUsers[this.selectedChoice?.ownerUserId].last}` 
        } else {
            if(this.selectedDecision.ownerUserId === usersModule.currentUserProfile.userId) {
                return 'You'
            }
            return `${decisionsModule.selectedDecisionUsers[this.selectedDecision.ownerUserId].first} ${decisionsModule.selectedDecisionUsers[this.selectedDecision.ownerUserId].last}`
        }
    }

    get editContent() {
        return workspaceOptionsModule.editContent;
    }

    private readonly URLS = Urls;
    private cleanChoiceForm:any = {};
    private unsavedChanges = false;
    private menu= false;    
    private shareOptions = [{name: 'View, Edit, & Delete', id: "ALL"}, {name: 'View & Edit', id: "EDIT"}, {name: 'View', id: "VIEW"}]
    private visibilityOptions = [{name: 'Public', id: "PUBLIC"}, {name: 'Private (only YOU have access)', id: "PRIVATE"}]
    private createChoiceDialog = false;
    private selectChoiceMenu = false;
    loading = false;
    valid = true;
    choiceForm: any = {};
    submissionId: any = null;
    submitting = false;
    convertError = false;
    requiredRule = [
        (v: string) => !!v || 'Field is required'
    ];

    @Ref()
    form: HTMLFormElement

    mounted() {
        if(this.isNewChoice){
        } else if (this.selectedChoice) {
            this.choiceForm = Object.assign({}, this.selectedChoice);
            this.submissionId = this.selectedChoice.id
            this.cleanChoiceForm = _.cloneDeep(this.choiceForm)
            this.unsavedChanges = false;
        }
        if (this.isNewChoiceNameDialog) {
            this.createChoiceDialog = true;
        }
    }

    @Watch("selectedChoice")
    private choiceSelected() {
        if (this.selectedChoice) {
            this.choiceForm = Object.assign({}, this.selectedChoice);
            this.submissionId = this.selectedChoice.id
            this.cleanChoiceForm = _.cloneDeep(this.choiceForm)
            this.unsavedChanges = false;
        } else {
            this.resetVars();
        }
    }

    private async imageChange() {
        if (this.choiceForm && this.submissionId) {
            this.submitting = true;
            NotificationEventBus.emitProcessingMessage();
            try {
                await choicesModule.updateChoiceImage({choiceId: this.choiceForm.id, image: this.choiceForm.image})
                NotificationEventBus.emitSuccessMessage();
            } catch (err) {
                NotificationEventBus.emitFailedMessage(err)
            }
            this.submitting = false;
        }
    }

    createChoice() {
        if (!this.form.validate()) {
            this.$emit('failSave');
            return;
        }

        this.submitting = true;
        
        if (this.isDialog) NotificationEventBus.emitProcessingMessage();
        if ( this.choiceForm && this.submissionId) {
            choicesModule.updateChoice({choice: this.choiceForm, refreshScoring: true})
                .then(() => {
                    NotificationEventBus.emitSuccessMessage();
                    this.submitting = false;
                    this.unsavedChanges = false;
                })
                .catch(err => {
                    this.submitting = false;
                    NotificationEventBus.emitFailedMessage(err)
                })
        } else {
            choicesModule.createChoice(this.choiceForm)
                .then(result => {
                    this.submitting = false;
                    choicesModule.setSelectedChoiceId(result.id);
                    if(this.activeChoiceLists?.length > 0 && this.addToList) {
                        decisionsModule.addChoiceToActiveLists(result.id)
                        choicesModule.fetchChoices()
                    }
                    NotificationEventBus.emitSuccessMessage();
                    NotificationEventBus.emitStaleSandboxScoringData('');
                    this.unsavedChanges = false;
                })
                .catch(err => {
                    this.submitting = false;
                    NotificationEventBus.emitFailedMessage(err)
                })
        }
        if(this.dialogSave){
            this.$emit('choiceSaved');
        }
    }

    private createNewChoice() {
        this.isEditChoiceName = false
        this.unsavedChanges = false;
        this.createChoiceDialog = true;
        //This line caused issues with START NEW button in app2 - don't see a reason for it but will keep it commented
        //this.navigateToChoiceUpdate();
    }

    private editChoiceName(){
        this.isEditChoiceName = true;
        this.createChoiceDialog = true;
    }
    private navigateToChoiceUpdate() {
        let re = new RegExp('[aA]{1}[pP]{2}');
        if (this.$router.currentRoute.path !== Urls.CHOICE_SUBMITTER && this.$router.currentRoute.path !== ('/app'+Urls.CHOICE_SUBMITTER) ) {
            if(re.test(this.$router.currentRoute.path)){
                this.$router.push({path:'/app' + Urls.CHOICE_SUBMITTER,query: this.$router.currentRoute.query});
            }else{
                this.$router.push({path:Urls.CHOICE_SUBMITTER,query: this.$router.currentRoute.query});
            }
        }
    }

    private resetVars() {
        this.submitting = false;
        this.choiceForm = {};
        this.submissionId = null;
        this.valid = true;
        this.unsavedChanges = false;
        this.choiceForm.shareSetting = "ALL"
        this.choiceForm.visibility = "PUBLIC"
        if (this.form) {
            this.form.reset();
        }
    }

    

    @Watch('choiceForm', {deep: true})
    private onChangeChoiceForm(newVal, oldVal) {
        if(!_.isEqual(newVal, this.cleanChoiceForm)) {
            this.unsavedChanges = true;
        }
    }

    get canUserAccessPermissions() {
        let usersModule = getModule(Users)
        console.log(this.selectedChoice)

        //If null then user can do whatever they want to their own new local choice
        if(this.selectedChoice == null) {
            return true;
        }

        //Owner of decision can always delete choices
        if(decisionsModule.selectedDecision.ownerUserId === usersModule.currentUserProfile.userId) {
            return true
        }

        //Can delete choices user is owner of
        if(this.selectedChoice.ownerUserId === usersModule.currentUserProfile.userId) {
            return true
        }


        //Reaching here means user is not owner of choice or decision
        return false
    }

    private cancelCreateChoice(){
        this.createChoiceDialog = false
        if(!this.isEditChoiceName){
            this.$emit('cancel');
        }

    }
    get editPermissions(): boolean {
        if(this.isNewChoice) {
            return true;
        }
        return getModule(Choices).checkChoiceEditPermissions
    }

    //This is used for the start new dialog - creates a new choice with name from CreateChoiceDialog
    async saveChoiceName(choiceName: string) {
        this.submitting = true;
        this.loading = true;
        console.log('save choice')
        // NotificationEventBus.emitProcessingMessage();
        if (choiceName != '') {
            if(this.isEditChoiceName){
                this.choiceForm.name = choiceName;
                this.createChoice();
                // NotificationEventBus.emitSuccessMessage();
            } else {
                this.choiceForm = {};
                let newChoice: any = {name: choiceName}
                await choicesModule
                    .createChoice(newChoice)
                    .then((result) => {
                        console.log('createChoice Result');
                        console.log(result);
                        this.submitting = false;
                        choicesModule.selectChoice(result.id);
                        if(this.activeChoiceLists?.length > 0) {
                            decisionsModule.addChoiceToActiveLists(result.id)
                            choicesModule.fetchChoices()
                        }
                        NotificationEventBus.emitSuccessMessage();
                        this.unsavedChanges = false;
                    })
                    .catch((err) => {
                        this.submitting = false;
                        NotificationEventBus.emitFailedMessage(err);
                    });
            
            }
        } else {

        }
        this.submitting = false;
        this.loading = false;
        this.createChoiceDialog = false;
    }
}
